var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("input", {
        ref: "hiddenFileInput",
        staticStyle: { display: "none" },
        attrs: { type: "file" },
        on: { change: _vm.uploadFileChange },
      }),
      _vm._l(_vm.localValue, function (item) {
        return [
          !item.readonly && !_vm.disabled
            ? [
                _c(
                  "a-button-group",
                  { staticStyle: { width: "100%" } },
                  [
                    _c(
                      "a-button",
                      {
                        staticStyle: {
                          width: "150px",
                          "text-align": "left",
                          overflow: "hidden",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.viewOrDownloadFile(item)
                          },
                        },
                      },
                      [
                        _c(
                          "a",
                          {
                            staticStyle: { "text-decoration": "underline" },
                            attrs: { title: item.name },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                item.name
                                  ? item.name.length > 7
                                    ? item.name.substring(0, 6) + "..."
                                    : item.name
                                  : ""
                              )
                            ),
                          ]
                        ),
                      ]
                    ),
                    _c("a-button", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: item.name && !_vm.disabled,
                          expression: "item.name&&!disabled",
                        },
                      ],
                      attrs: {
                        disabled: _vm.disabled,
                        type: "danger",
                        icon: "delete",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.deleteFile(item)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm.localValue && _vm.localValue.length
            ? [
                _c(
                  "span",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "100%",
                      "font-size": "14px",
                      "line-height": "30px",
                      "font-weight": "700",
                      color: "#3498db",
                      "text-decoration": "underline",
                      cursor: "pointer",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.viewOrDownloadFile(item)
                      },
                    },
                  },
                  [_vm._v(_vm._s(item.name))]
                ),
              ]
            : [
                _c(
                  "span",
                  {
                    staticStyle: {
                      display: "inline-block",
                      width: "100%",
                      "font-size": "14px",
                      "line-height": "30px",
                      "font-weight": "700",
                      color: "#7c7c7c",
                    },
                  },
                  [_vm._v("暂无附件")]
                ),
              ],
        ]
      }),
      !_vm.disabled
        ? _c(
            "a-button",
            {
              attrs: {
                type: "primary",
                icon: "upload",
                loading: _vm.iconLoading,
              },
              on: { click: _vm.choiceImg },
            },
            [_vm._v(" 上传 ")]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }